import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AppLoadingService {
  private readonly loadingSubject = new BehaviorSubject<boolean>(false);

  readonly isLoading$: Observable<boolean> = this.loadingSubject.asObservable().pipe(distinctUntilChanged());

  start(): void {
    this.loadingSubject.next(true);
  }

  stop(): void {
    this.loadingSubject.next(false);
  }

  get isLoading(): boolean {
    return this.loadingSubject.value;
  }
}
